import { render, staticRenderFns } from "./ModalDataEvasione.vue?vue&type=template&id=091f3490"
import script from "./ModalDataEvasione.vue?vue&type=script&lang=js"
export * from "./ModalDataEvasione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports